import { Modal } from "@/components/Modal";
import { MagicIcon } from "@/components/common/icons/MagicIcon";
import React from "react";
import { useBot } from "@/api/useBot";
import { useTranslate } from "@/api/useTranslate";
import TextareaAutosize from "react-textarea-autosize";
import { DotsLoader } from "@/components/common/Loader/DotsLoader";
import { Button } from "@/components/common/Button";
import { CopyIcon } from "@/components/common/icons/CopyIcon";
import { SpeakerIcon } from "@/components/common/icons/SpeakerIcon";
import { Field, Form, Formik } from "formik";
import { object, string } from "yup";
import { copy } from "@/utils/copy";
import { useAudio } from "@/api/useAudio";

import styles from "./TranslateModal.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const TranslateModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { data: bot } = useBot();
  const { playText } = useAudio();
  const { data, translateTo, isLoading, reset } = useTranslate();
  const [input, setInput] = React.useState("");

  return (
    <Modal withX className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <MagicIcon className={styles.icon} />
      <h1 className={styles.title}>Traduction du français vers l'anglais</h1>
      {!data && !isLoading && (
        <Formik
          validationSchema={object().shape({
            message: string().min(1).max(255),
          })}
          initialValues={{ message: "" }}
          onSubmit={({ message }) => {
            setInput(message);
            return translateTo(message);
          }}
        >
          {({ isValid, submitForm }) => (
            <Form className={styles.form}>
              <Field name="message">
                {({ field }: any) => (
                  <TextareaAutosize
                    className={styles.input}
                    placeholder="Entrez la phrase..."
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        if (isValid) {
                          submitForm();
                        }
                      }
                    }}
                    {...field}
                  />
                )}
              </Field>
              <Button
                disabled={!isValid}
                type="submit"
                className={styles.button}
              >
                {/* Translate to {bot?.language} */}
                Traduire en anglais
              </Button>
            </Form>
          )}
        </Formik>
      )}
      {!data && isLoading && <DotsLoader className={styles.loader} />}
      {data && (
        <>
          <div className={styles.translation}>
            <Button
              onClick={() => copy(data.data)}
              variant="clean"
              className={styles.tranlationCopy}
            >
              {data.data} <CopyIcon />
            </Button>
            <Button
              onClick={() => {
                playText(data.data, bot!.voice);
              }}
              variant="clean"
              className={styles.speaker}
            >
              <SpeakerIcon />
            </Button>
          </div>
          <div className={styles.inputText}>{input}</div>

          <Button variant="clean" className={styles.reset} onClick={reset}>
            Réinitialiser
          </Button>
        </>
      )}
    </Modal>
  );
};
